



























































import Vue from 'vue'
import { getWebAppCaps } from '@/api/checkout'
import moment from 'moment'
import PreviewImage from './components/PreviewImage.vue'
import { setBookOrderInfo } from '@/api/personalbook'
import { IBookOrderRequest } from '@/interfaces/personalbook'
import { generateImagePath } from '@/utils'
import store from '@/store'
import * as Event from '@/utils/sendEvent'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { HeaderMap } from '@/constants/personalBook'
import { MetaInfo } from 'vue-meta/types/vue-meta'
export default Vue.extend({
  name: 'BookPreview',
  components: { PreviewImage },
  data () {
    return {
      bookInfo: {
        name: '' as string,
        faceType: 0,
        traitSelected: '00000000',
        materialSelected: 0,
        cover: 2,
        backgroundSelected: 0,
        message: '' as string,
        imagePath: '' as string
      },
      alertMsg: '請左右滑動並確認所有圖片後，進行下一步操作。',
      imageLoaded: false,
      isLoading: false,
      isZoomInMode: false,
      preview_url: '',
      isScrollEnd: false,
      appCaps: {
        comp_resp_credit: 1,
        upload_image_server: 'https://nuphoto.us/118_UploadImageServer_tok.php',
        book_preview_server: 'https://nuphoto.com.tw/personalbook/gen_book_api.php'
      }
    }
  },
  metaInfo (): MetaInfo {
    return {
      title: '預覽童書',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  async created () {
    this.isLoading = true
    postAppMessage(MessageHandlers.UPDATE_HEADER, HeaderMap.PREVIEW)
    window.navigateBack = () => this.$router.go(-1)
    this.loadBookInfoFromLocalStorage()

    if (this.bookInfo.imagePath.length === 0) {
      const prefix = store.getters['webview/platform']
      this.bookInfo.imagePath = generateImagePath(prefix)
      // this.$store.commit('logger/SET_IMAGE_PATH', this.bookInfo.imagePath)
      this.saveBookInfoToLocalStorage()
    }
    console.log(this.bookInfo.imagePath)

    // get upload server url
    if (this.$store.getters.webAppCaps) {
      this.appCaps = this.$store.getters.webAppCaps
    } else {
      const { data } = await getWebAppCaps({ ver_no: this.$store.getters['webview/ver_no'] })
      this.appCaps = data
    }
  },
  methods: {
    handleScroll () {
      const image = this.$refs.preview as HTMLElement
      if (image.scrollLeft + image.clientWidth + 15 >= image.scrollWidth) {
        this.isScrollEnd = true
      }
    },
    saveBookInfoToLocalStorage () {
      localStorage.setItem('bookInfo', JSON.stringify({
        name: this.bookInfo.name,
        faceType: this.bookInfo.faceType || 0,
        traitSelected: this.bookInfo.traitSelected,
        materialSelected: this.bookInfo.materialSelected || 0,
        cover: this.bookInfo.cover === undefined ? 2 : this.bookInfo.cover,
        backgroundSelected: this.bookInfo.backgroundSelected || 0,
        message: this.bookInfo.message,
        imagePath: this.bookInfo.imagePath
      }))
    },
    loadBookInfoFromLocalStorage () {
      const dataString = localStorage.getItem('bookInfo') || ''
      if (dataString) {
        const data = JSON.parse(dataString)
        if (data.name.length === 0 || data.traitSelected.length === 0 || data.traitSelected === '00000000') {
          this.$router.replace({ name: 'PersonalBook' })
        }
        this.bookInfo.name = data.name
        this.bookInfo.faceType = data.faceType
        this.bookInfo.traitSelected = data.traitSelected
        this.bookInfo.materialSelected = data.materialSelected
        this.bookInfo.cover = data.cover
        this.bookInfo.backgroundSelected = data.backgroundSelected
        this.bookInfo.message = data.message
        this.bookInfo.imagePath = data.imagePath
      } else {
        this.$router.replace({ name: 'PersonalBook' })
      }
    },
    getImageLoaded (imageLoaded: number) {
      this.isLoading = false
      console.log(imageLoaded)
    },
    onBlackButtonClicked () {
      this.$bvModal.msgBoxOk(this.alertMsg, {
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        footerClass: 'msgbox-ok-footer',
        okTitle: '確定'
      })
    },
    async onFinishClicked () {
      this.isLoading = true

      // Set token
      let token = this.$store.getters.token
      if (this.$route.query.webview === '1') {
        token = this.$route.query.token || this.$store.getters.token
      }

      // Set orderId
      const orderId = this.gernerateOrderId()
      this.$store.commit('logger/PUSH_LOG', { orderId })
      if (orderId === undefined) {
        this.isLoading = false
        throw new Error('訂單號碼錯誤')
      }

      try {
        const requestBody = {
          token,
          order_id: orderId,
          app_index: process.env.VUE_APP_INDEX,
          product: '100',
          product_num: 1,
          uname: '',
          utel: '',
          umail: '',
          rec_name: '',
          rec_address: '',
          rec_phone: '',
          rec_country: '',
          rec_company: '',
          tel_country: '',
          image_number: 1,
          image_filename: '',
          image_path: this.bookInfo.imagePath,
          duplicate_num: '1',
          image_ISO: '',
          model_name: '',
          original_width: '',
          original_height: '',
          date_time: '',
          style_id: '0',
          caption: '',
          tx_status: 13,
          tx_type: 0,
          print_datetime: 0,
          amount: 0,
          ver_no: this.$store.getters['webview/ver_no'],
          device: this.$store.getters['webview/device'],
          os_ver: this.$store.getters['webview/os_ver'],
          bank_id: '',
          item_number: '',
          onemore: '',
          style_ver: 14,
          merge_order_id: '',
          deliver_fee: '',
          amount_msg: '',
          mode: 0,
          receipt_no: '',
          cpid: '',
          coin_used: '',
          coin_add: '',
          prime_join: 0,
          prime_cnt: 0,
          prime_cnt_add: '+0',
          calendar1_stmonth: '',
          product_model: this.bookInfo.materialSelected + '',
          resp: this.appCaps.comp_resp_credit,
          bank_name: this.$store.getters['webview/bank_name'],
          upload_image_server: this.appCaps.upload_image_server,
          book_name: this.bookInfo.name,
          book_faceType: this.bookInfo.faceType,
          book_traitSelected: this.bookInfo.traitSelected,
          book_materialSelected: this.bookInfo.materialSelected,
          book_cover: this.bookInfo.cover,
          book_backgroundSelected: this.bookInfo.backgroundSelected,
          book_message: this.bookInfo.message,
          cal1_cost: this.$store.getters['webview/cal1_cost'],
          book_preview_server: this.appCaps.book_preview_server
        } as IBookOrderRequest
        this.$store.commit('logger/PUSH_LOG', { setOrderInfoRequest: requestBody })

        const { data } = await setBookOrderInfo(requestBody)
        console.log(data)
        if (data[0].flag === 0) {
          console.log('setBookOrder success', orderId)
          Event.addToCart(100, '客製化童書-勇闖馬可洛', 1)
          setTimeout(() => {
            this.isLoading = false
            if (this.$store.getters.isWebViewMode) {
              postAppMessage(MessageHandlers.ON_BOOK_UPLOAD_SUCCESS, true)
            } else {
              this.$router.replace({ name: 'Cart' })
            }
            this.bookInfo.name = ''
            this.bookInfo.faceType = 0
            this.bookInfo.traitSelected = '00000000'
            this.bookInfo.materialSelected = 0
            this.bookInfo.cover = 2
            this.bookInfo.backgroundSelected = 0
            this.bookInfo.message = ''
            this.bookInfo.imagePath = ''
            // this.$store.commit('logger/SET_IMAGE_PATH', this.bookInfo.imagePath)
            this.saveBookInfoToLocalStorage()
          }, 4000)
        } else {
          this.isLoading = false
          this.$store.commit('logger/PUSH_LOG', data.msg)
          this.$bvModal.msgBoxOk(data.msg, {
            centered: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          })
        }
      } catch (error) {
        this.isLoading = false
        this.$store.commit('logger/PUSH_LOG', error)
        this.$bvModal.msgBoxOk(`加入購物車時發生錯誤，請檢查您的網路狀態是否不佳，若有問題請聯絡客服。錯誤：${error.message}`, {
          centered: true,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      } finally {
        // this.isLoading = false
      }
    },
    gernerateOrderId () {
      let randomStr = ''
      for (let i = 0; i < 5; i++) {
        randomStr += Math.floor(Math.random() * 10)
      }
      var formattedDate = moment().format('YYMMDDHHmmssSSS')
      const orederId = `${formattedDate}${randomStr}`
      console.log(orederId)
      return orederId.length === 20 ? orederId : undefined
    }
  }
})
